import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";
import "../../styles/styles.css";
import axios from "axios";
import { Article } from "../../data/types";

const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

interface PageArticlesProps {
  nombre?: number; // prop optionnelle
}

const PageArticles: React.FC<PageArticlesProps> = ({ nombre }) => {
  const [articles, setArticles] = useState<Article[]>([]);

  useEffect(() => {
    const getArticles = async () => {
      try {
        const response = await axiosInstance.get("api/articles/Articles");
        setArticles(response.data);
      } catch (error) {
        console.log("erreur:" + error);
      }
    };
    getArticles();
  }, []);

  // Si nombre est défini, on ne prend que les `nombre` premiers articles
  const displayedArticles = nombre ? articles.slice(0, nombre) : articles;

  return (
    <div className="stretch bgColor">
      <div className="container py-3 lg:py-4">
        {/* HEADER */}
        <h2 className="inline-block align-middle text-4xl font-semibold md:text-5xl">
          Articles
        </h2>

        {/* TEXTE + BOUTON */}
        {nombre ? (
          <div className="flex items-center gap-3 mt-2">
            <span style={{ color: "black" }}>Les {displayedArticles.length} plus récents articles</span>
            <a
              href="/articles"
              className="inline-block px-3 py-1 text-white bg-primary-6000 rounded-full hover:bg-primary-700 transition-colors duration-200 text-sm"
            >
              Voir plus d’articles
            </a>
          </div>
        ) : (
          <span style={{ color: "black" }} className="block mt-2">
            {articles.length} articles
          </span>
        )}
        {/* ====================== END HEADER ====================== */}

        <div className="mt-2 flex flex-col sm:items-center sm:justify-between sm:flex-row">
          <div className="block border-b w-full border-neutral-500 sm:hidden"></div>
          <div className="flex justify-end"></div>
        </div>

        {/* LOOP ITEMS */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-3 gap-y-4 md:gap-x-4 md:gap-y-5 mt-2 lg:mt-2">
          {displayedArticles.map((post: any) => (
            <Card key={post.id} post={post} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PageArticles;
